export default "__VITE_ASSET__CuZzSpb7__"